import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { EVENT_KINDS, canSeeContent, getVisibility, labelFor, listEvents } from "@hub";
import { useHubVisitor, withVisitor } from "../hubContext";

function monthKey(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export default function CalendarPage() {
  const visitor = useHubVisitor();
  const visibility = getVisibility();
  const [cursor, setCursor] = useState(() => new Date(2026, 8, 1));
  const key = monthKey(cursor);

  const events = useMemo(
    () =>
      listEvents()
        .filter((item) => canSeeContent(item.visibility, visitor.role || "public"))
        .filter((item) => String(item.starts_on || "").startsWith(key)),
    [visitor.role, key]
  );

  if (visibility.events === false) {
    return (
      <article>
        <h1>Calendar</h1>
        <p className="lead">Events are hidden for now.</p>
      </article>
    );
  }

  return (
    <article>
      <h1>Journey calendar</h1>
      <p className="lead">
        Hub events for San Diego County, grouped by month. The same listings populate the REChecklist
        desk calendar when they are relevant to the signed-in role. Southern California is Phase I
        expansion.
      </p>
      <div className="calendar-nav">
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1))}
        >
          Previous
        </button>
        <strong>
          {cursor.toLocaleString(undefined, { month: "long", year: "numeric" })}
        </strong>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1))}
        >
          Next
        </button>
      </div>
      <div className="card-grid">
        {events.map((item) => (
          <article key={item.id} className="card">
            <p className="muted">
              {item.starts_on} {item.starts_at ? `· ${item.starts_at}` : ""} · {labelFor(EVENT_KINDS, item.kind)}
            </p>
            <h2>{item.title}</h2>
            <p>
              {item.location} · {item.region || "San Diego County"}
            </p>
            <p>{item.summary}</p>
            <p>
              <Link to={withVisitor(`/events/${item.id}`, visitor)}>Open event</Link>
            </p>
          </article>
        ))}
      </div>
      {!events.length ? (
        <p className="placeholder-note">No hub events in this month. Browse the full directory on Events.</p>
      ) : null}
      <p>
        <Link to={withVisitor("/events", visitor)}>All events</Link>
      </p>
    </article>
  );
}
